import axios from "axios";
// import { Base_Api } from "../config";
const axiosInstance = axios.create({
  // baseURL: 'https://api.apexprimeeducation.com/api',
  baseURL: 'https://apexeducationapi.dev-mn.xyz/api',
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token")
    const SubToken = localStorage.getItem("SubToken")
    return {
      ...config,
      headers: {
        Authorization: `Bearer ${token||SubToken}`,
        Accept: "application/json",
        "Content-Type" : "mutlipart/form-data"
      }
    };
  },

  (error) => {
    console.error("Request Interceptor Error:", error);
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (res) => res,
  (error) =>
    Promise.reject(
      (error.response && error.response.data) || "Something Went Wrong"
    )
);
export default axiosInstance;



